import { Injectable } from "@angular/core";
import { ActionWithPayload } from "@obg/ngrx-utils";

import {
	SmartIdCompleteRegistrationPayload,
	SmartIdSimpleRegistrationPayload,
} from "./registration-with-smart-id.model";

export const ACTION_PREFIX = "[Registration With Smart ID]";

export const REGISTRATION_WITH_SMART_ID_ACTION_TYPE = {
	/**
	 * Dispatched to start registration with smart id process.
	 */
	getSmartIdSimpleRegistrationToken: `${ACTION_PREFIX} Get Simple Smart ID Registration Token`,
	getSmartIdCompleteRegistrationToken: `${ACTION_PREFIX} Get Complete Smart ID Registration Token`,
};

@Injectable({
	providedIn: "root",
})
export class RegistrationWithSmartIdAction {
	getSmartIdSimpleRegistrationToken(payload: SmartIdSimpleRegistrationPayload): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SMART_ID_ACTION_TYPE.getSmartIdSimpleRegistrationToken,
			payload,
		};
	}

	getSmartIdCompleteRegistrationToken(payload: SmartIdCompleteRegistrationPayload): ActionWithPayload {
		return {
			type: REGISTRATION_WITH_SMART_ID_ACTION_TYPE.getSmartIdCompleteRegistrationToken,
			payload,
		};
	}
}
